import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CloseCircle } from '../../assets/icons/close-circle.svg';

interface ModalBoxProperties {
  title: string | null;
  content: JSX.Element | null;
  closeModal: () => void;
  open: boolean;
  header: boolean;
  rightCorner?: string;
  modalBoxAnimation?: 'modalAnimateToTop' | 'modalAnimateToLeft';
  notification?: boolean;
  fullHeightWidth?: boolean;
  version?: string;
  position?:
    | 'center'
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right'
    | 'top-right'
    | 'bottom-right'
    | 'top-left'
    | 'bottom-left';
}

/**
 * Common modal box
 */
function ModalBox({
  title,
  content,
  closeModal,
  open,
  header,
  rightCorner,
  modalBoxAnimation,
  notification,
  fullHeightWidth,
  version,
  position,
}: ModalBoxProperties) {
  const reference = useRef<HTMLDivElement>(null);
  const { i18n } = useTranslation();

  return open
    ? ReactDOM.createPortal(
        <div
          className={`modal-box-wrap ${open ? 'open' : ''} ${rightCorner ? 'right-top' : ''} ${position || ''} ${i18n.language === 'ar' ? 'rtl' : ''}`}
          ref={reference}>
          <div
            style={
              {
                '--modal-animation': modalBoxAnimation,
                ...(fullHeightWidth && {
                  height: '100%',
                  width: '100%',
                }),
              } as React.CSSProperties
            }
            className="modal-box-container">
            {header && (
              <div className={`modal-box-header-${version}`}>
                <div className="modal-box-title">
                  <span>{title}</span>
                </div>
                {!notification && (
                  <div className="modal-box-icon" onClick={closeModal} role="presentation">
                    <CloseCircle />
                  </div>
                )}
              </div>
            )}
            <div className="modal-box-body">
              {!header && !notification && (
                <div className="modal-box-icon" onClick={closeModal} role="presentation">
                  <CloseCircle />
                </div>
              )}
             <div className='content'>{content}</div> 
            </div>
          </div>
        </div>,
        document.body,
      )
    : null;
}

ModalBox.defaultProps = {
  rightCorner: false,
  modalBoxAnimation: 'modalAnimateToTop',
  notification: false,
  fullHeightWidth: false,
  version: 'v1',
  position: 'center',
};

export default ModalBox;
